module.exports = __webpack_public_path__ + "cd6b398f822377c0768e0cb0ae295bae.jpeg";